import { jsx as r, jsxs as m } from "react/jsx-runtime";
import { useRef as C, useEffect as N } from "react";
import { useTranslation as T } from "react-i18next";
import y from "react-slick";
import h from "@mui/material/Box";
import R from "@mui/material/CardMedia";
import w from "@mui/material/Container";
import u from "@mui/material/Grid";
import g from "@mui/material/Typography";
import { makeStyles as I } from "tss-react/mui";
import { useLanguageContext as v } from "@lumirental/lumi-web-shared/lib/contexts/Language.context";
import { manageSmoothScrolling as B } from "../../../../../utils/index.js";
import k from "../../../../common/Button/Button.js";
import { CardBase as a } from "../../../../common/Cards/CardBase/CardBase.js";
import G from "../../../../common/Tag/Tag.js";
import { useBusRentalContext as x } from "../../BusRental.context.js";
import M from "./OurRoutes.style.js";
const f = I()(M), Q = ({ list: e }) => {
  const { classes: o } = f(), i = C(), { isArabic: l } = v(), c = {
    dots: !1,
    infinite: !0,
    arrows: !1,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    rtl: l
  };
  return N(() => {
    const n = l ? e.length - 1 : 0, s = setTimeout(() => {
      var t;
      (t = i == null ? void 0 : i.current) == null || t.slickGoTo(n);
    }, 0);
    return () => clearTimeout(s);
  }, []), /* @__PURE__ */ r(h, { className: o.sliderWrapper, children: /* @__PURE__ */ r(y, { ...c, ref: i, children: e && e.map((n) => {
    const s = (n == null ? void 0 : n.id) ?? 0;
    return /* @__PURE__ */ r(u, { item: !0, sx: { height: "100%" }, children: /* @__PURE__ */ r(S, { data: n }) }, s);
  }) }) });
}, S = ({ data: e }) => {
  var d;
  const { classes: o } = f(), { t: i } = T(), { setSelectedRoute: l } = x(), c = (e == null ? void 0 : e.code) ?? "", n = (e == null ? void 0 : e.route) ?? "", s = (e == null ? void 0 : e.duration) ?? "", t = ((d = e == null ? void 0 : e.img) == null ? void 0 : d.url) ?? "", p = (b) => {
    B("#routeInfoForm"), l(b);
  };
  return /* @__PURE__ */ m(a, { className: o.card, children: [
    /* @__PURE__ */ m(h, { className: o.imgWrapper, children: [
      /* @__PURE__ */ r(
        R,
        {
          sx: { height: 190 },
          image: t,
          title: "green iguana",
          className: o.bgImg
        }
      ),
      s && /* @__PURE__ */ r(G, { label: s, variant: "gray", className: o.duration })
    ] }),
    /* @__PURE__ */ m(a.Content, { sx: { padding: 2 }, children: [
      /* @__PURE__ */ r(g, { variant: "h3", mb: { xs: 2 }, className: o.label, children: n }),
      /* @__PURE__ */ r(
        k,
        {
          fullWidth: !0,
          dataTestid: "getRouteQuoteId",
          onClick: () => p(c),
          className: o.getQuoteCta,
          children: i("get_a_quote!")
        }
      )
    ] })
  ] });
}, W = ({ data: e }) => {
  const { classes: o } = f(), i = (e == null ? void 0 : e.heading) ?? "", l = (e == null ? void 0 : e.subHeading) ?? "", c = (e == null ? void 0 : e.list) ?? [], { isMobile: n } = x(), s = n;
  return /* @__PURE__ */ r(h, { py: { xs: 6, sm: 10, md: 15 }, className: o.wrapper, children: /* @__PURE__ */ r(w, { sx: { paddingRight: s ? 0 : 2 }, children: /* @__PURE__ */ m(
    u,
    {
      container: !0,
      columnSpacing: s ? 0 : 3,
      rowSpacing: s ? 0 : 4,
      children: [
        /* @__PURE__ */ m(u, { item: !0, xs: 12, sx: { textAlign: "center" }, children: [
          /* @__PURE__ */ r(g, { variant: "h1", mb: { xs: 1 }, className: o.heading, children: i }),
          /* @__PURE__ */ r(
            g,
            {
              variant: "h4",
              mb: { xs: 3, md: 2 },
              className: o.description,
              children: l
            }
          )
        ] }),
        s ? /* @__PURE__ */ r(Q, { list: c }) : c && c.map((t) => {
          const p = (t == null ? void 0 : t.id) ?? 0;
          return /* @__PURE__ */ r(u, { item: !0, xs: 4, children: /* @__PURE__ */ r(S, { data: t }) }, p);
        })
      ]
    }
  ) }) });
}, X = W;
export {
  X as default
};
